// extracted by mini-css-extract-plugin
export var cardLayout = "_28-1";
export var paginationContainer = "_28-0";